import React from 'react';

const ValueProposition2 = ({ ...props }) => (
  <svg
    width="487"
    height="536"
    viewBox="0 0 487 536"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M487 447.337C487 452.612 485.961 457.835 483.942 462.709C481.924 467.582 478.965 472.01 475.235 475.74C471.505 479.47 467.077 482.429 462.204 484.447C457.331 486.466 452.107 487.505 446.832 487.505H436.278V525.458C436.278 528.121 435.22 530.675 433.337 532.559C431.453 534.442 428.899 535.5 426.236 535.5H66.0003C63.3371 535.5 60.7829 534.442 58.8996 532.559C57.0164 530.675 55.9584 528.121 55.9584 525.458V487.505H40.1676C29.5145 487.505 19.2977 483.273 11.7648 475.74C4.2319 468.207 0 457.99 0 447.337V151.13C0 111.181 15.8697 72.8672 44.118 44.6186C72.3663 16.3699 110.679 0.5 150.628 0.5H336.372C376.321 0.5 414.634 16.3699 442.882 44.6186C471.13 72.8672 487 111.181 487 151.13V447.337Z"
      fill="#14477D"
    />
  </svg>
);

export default ValueProposition2;
